import {charcoal} from '../sass/base/_exports.sass';

export const FontSizeIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 22, height = 14} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.54813 11.5198H11.5801L7.29213 0.319824H5.11613L0.828125 11.5198H2.86013L3.80413 8.95982H8.60413L9.54813 11.5198ZM4.57213 6.86382C5.29213 4.92782 5.82013 3.40782 6.20413 1.95182C6.58813 3.40782 7.13213 4.92782 7.83613 6.86382L7.99613 7.27983H4.41213L4.57213 6.86382Z"
        fill={color}
      />
      <path
        d="M19.9688 11.5198C19.5048 10.4478 19.4888 10.3038 19.4888 9.27983V5.87182C19.4888 4.19182 18.1927 3.32782 16.0647 3.32782C13.9207 3.32782 12.6247 4.15982 12.6247 5.82382H14.5608C14.5767 5.15182 15.1528 4.81582 16.0647 4.81582C17.0247 4.81582 17.5688 5.13582 17.5688 5.83982C17.5688 7.72782 12.3368 5.91982 12.3368 9.34382C12.3368 10.8798 13.4567 11.6798 14.9127 11.6798C16.1127 11.6798 17.0728 11.1358 17.5688 10.1918L18.0328 11.5198H19.9688ZM14.3047 9.11983C14.3047 7.79183 16.4167 7.88783 17.5688 7.16782V8.17583C17.5688 9.50383 16.6407 10.2238 15.6648 10.2238C14.8007 10.2238 14.3047 9.88783 14.3047 9.11983Z"
        fill={color}
      />
    </svg>
  );
};
